
import { Modal } from "antd";
import { BusinessAutocomplete } from "./BusinessAutocomplete";
import { DrawerPanelTitle, modalPanelStyles } from "../../../../common/Drawers/DrawerPanelTitle";

export const LeadModal = (props: { benchmarkMap: any, onFinish: any }) => {        
    
    return (
        <Modal
            width={'60%'}
            open={true}
            onOk={props.onFinish}            
            onCancel={props.onFinish}            
            footer={null}                           
            style={{ top: 20 }}
            {...modalPanelStyles}
            title={<DrawerPanelTitle title="Añadir lead" />}
        >   
            <br/>          
			<div>
                <h3>Busca el negocio en Google Maps</h3>                
                <BusinessAutocomplete onBusinessSelect={props.onFinish} />
            </div>
                     
        </Modal>            									                
    );
};
